// @flow
import React, { Fragment } from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";

import AgentSocial from "../../../agent-detail/AgentSocial";

import type { $Agent, $Site, $Team } from "flow/types";

type $Props = {
  agent: $Agent,
  classes: Object,
  site: $Site,
  team: $Team,
};

const Info = ({ agent, classes, site, team }: $Props) => {
  if (site.userId && agent) {
    return (
      <Fragment>
        <Typography className={classes.subHeading} type="heading6">
          <a href="/">{agent.fullName}</a>
        </Typography>
        <Typography className={classes.title} type="body">
          {agent.title}
        </Typography>
        {agent.socialMedia ? (
          <AgentSocial
            className={classes.social}
            socialMedia={agent.socialMedia}
          />
        ) : null}
      </Fragment>
    );
  } else if (site.teamId && team) {
    return (
      <Fragment>
        {team.logoPath ? (
          <div className={classes.teamLogo}>
            <img
              src={team.logoPath}
              alt={team.name || ""}
              title={team.name || ""}
            />
          </div>
        ) : null}
        <Typography className={classes.subHeading} type="heading6">
          {team.name}
        </Typography>
        {site.socialMedia ? (
          <AgentSocial
            className={classes.social}
            socialMedia={site.socialMedia}
          />
        ) : null}
      </Fragment>
    );
  }
};

const styles = (theme) => ({
  title: {
    margin: "0 auto 12px",
    color: theme.colors.primaryFontColor,
  },
  subHeading: {
    margin: "0",
    color: theme.colors.white,
  },
  social: {
    justifyContent: "center",
    "& a": {
      color: `${theme.colors.white} !important`,
    },
  },
  teamLogo: {
    position: "relative",
    margin: "0 auto",
    width: "100%",
    maxWidth: "180px",
    "& img": {
      display: "block",
      margin: "0 auto",
      width: "100%",
      height: "auto",
    },
  },
});

export default withGlobalContext(withStyles(styles)(Info));
